import { useState } from "react";
import axios from "axios";
import "./CriarVaga.css";

export default function CriarVaga({
    aberto,
    onClose,
    atualizarVagas
}) {

    const [vaga, setVaga] =
        useState("");

    const [cidade, setCidade] =
        useState("");

    const [endereco, setEndereco] =
        useState("");

    const [horario, setHorario] =
        useState("");

    const [descricao, setDescricao] =
        useState("");

    const [atividade, setAtividade] =
        useState("");

    const [atividades, setAtividades] =
        useState([]);

    const [requisito, setRequisito] =
        useState("");

    const [requisitos, setRequisitos] =
        useState([]);

    const [beneficio, setBeneficio] =
        useState("");

    const [beneficios, setBeneficios] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [erro, setErro] =
        useState("");

    if (!aberto) return null;

    function adicionarAtividade() {

        if (!atividade.trim()) return;

        setAtividades([
            ...atividades,
            atividade.trim()
        ]);

        setAtividade("");
    }

    function adicionarRequisito() {

        if (!requisito.trim()) return;

        setRequisitos([
            ...requisitos,
            requisito.trim()
        ]);

        setRequisito("");
    }

    function adicionarBeneficio() {

        if (!beneficio.trim()) return;

        setBeneficios([
            ...beneficios,
            beneficio.trim()
        ]);

        setBeneficio("");
    }

    function removerAtividade(index) {

        setAtividades(
            atividades.filter(
                (_, i) => i !== index
            )
        );
    }

    function removerRequisito(index) {

        setRequisitos(
            requisitos.filter(
                (_, i) => i !== index
            )
        );
    }

    function removerBeneficio(index) {

        setBeneficios(
            beneficios.filter(
                (_, i) => i !== index
            )
        );
    }

    async function criarVaga() {

        setErro("");

        if (
            !vaga ||
            !cidade ||
            !endereco ||
            !horario ||
            !descricao
        ) {

            setErro(
                "Preencha todos os campos obrigatórios."
            );

            return;
        }

        const body = {

            vaga,

            cidade,

            endereco,

            desc_horario: horario,

            desc_vaga: descricao

        };

        if (atividades.length) {
            body.atividades =
                atividades;
        }

        if (requisitos.length) {
            body.requisitos =
                requisitos;
        }

        if (beneficios.length) {
            body.beneficios =
                beneficios;
        }

        try {

            setLoading(true);

            console.log("BODY ENVIADO:");
console.log(body);

            await axios.post(
                "https://app.eliandroalimentos.com.br/api/vagas/criar",
                body
            );

            await atualizarVagas();

            onClose();

       } catch (err) {

    console.log("========== ERRO AO CRIAR VAGA ==========");

    console.log("Erro completo:", err);

    console.log("Response:", err.response);

    console.log("Status:", err.response?.status);

    console.log("Data:", err.response?.data);

    console.log("Headers:", err.response?.headers);

    console.log("Request:", err.request);

    console.log("Message:", err.message);

    console.log("========================================");

    if (err.response?.data?.error) {

        setErro(
            err.response.data.error
        );

    } else if (err.response?.data?.errors) {

        console.log(
            "Erros de validação:",
            err.response.data.errors
        );

        setErro(
            err.response.data.errors
                .map(e => e.msg)
                .join(" | ")
        );

    } else if (err.message) {

        setErro(err.message);

    } else {

        setErro(
            "Erro ao criar vaga."
        );

    }

} finally {

            setLoading(false);

        }

    }

    return (

    <div
        className="criarvaga-overlay"
        onClick={onClose}
    >

        <div
            className="criarvaga-card"
            onClick={(e) =>
                e.stopPropagation()
            }
        >

            <h2>
                Criar Nova Vaga
            </h2>

            {/* Nome e Cidade */}
            <div className="criarvaga-grid">

                <div>

                    <label>
                        Nome da vaga *
                    </label>

                    <input
                        value={vaga}
                        onChange={(e) =>
                            setVaga(e.target.value)
                        }
                    />

                </div>

                <div>

                    <label>
                        Cidade *
                    </label>

                    <input
                        value={cidade}
                        onChange={(e) =>
                            setCidade(e.target.value)
                        }
                    />

                </div>

            </div>

            {/* Endereço e Horário */}
            <div className="criarvaga-grid2">

                <div>

                    <label>
                        Endereço *
                    </label>

                    <input
                        value={endereco}
                        onChange={(e) =>
                            setEndereco(e.target.value)
                        }
                    />

                </div>

                <div>

                    <label>
                        Horário *
                    </label>

                    <input
                        value={horario}
                        onChange={(e) =>
                            setHorario(e.target.value)
                        }
                    />

                </div>

            </div>

            <label>
                Descrição da vaga *
            </label>

            <textarea
                rows={4}
                value={descricao}
                onChange={(e) =>
                    setDescricao(e.target.value)
                }
            />

            {/* LISTAS */}
            <div className="criarvaga-listas">

                {/* Atividades */}

                <div className="lista-box">

                    <h3>Atividades</h3>

                    <div className="linha-add">

                        <input
                            value={atividade}
                            onChange={(e) =>
                                setAtividade(e.target.value)
                            }
                        />

                        <button
                            type="button"
                            onClick={adicionarAtividade}
                        >
                            Adicionar
                        </button>

                    </div>

                    <div className="itens-lista">

                        {atividades.map(
                            (item, index) => (

                                <div
                                    className="item-lista"
                                    key={index}
                                >

                                    <span>{item}</span>

                                    <button
                                        type="button"
                                        className="btn-remover"
                                        onClick={() =>
                                            removerAtividade(index)
                                        }
                                    >
                                        ✕
                                    </button>

                                </div>

                            )
                        )}

                    </div>

                </div>

                {/* Requisitos */}

                <div className="lista-box">

                    <h3>Requisitos</h3>

                    <div className="linha-add">

                        <input
                            value={requisito}
                            onChange={(e) =>
                                setRequisito(e.target.value)
                            }
                        />

                        <button
                            type="button"
                            onClick={adicionarRequisito}
                        >
                            Adicionar
                        </button>

                    </div>

                    <div className="itens-lista">

                        {requisitos.map(
                            (item, index) => (

                                <div
                                    className="item-lista"
                                    key={index}
                                >

                                    <span>{item}</span>

                                    <button
                                        type="button"
                                        className="btn-remover"
                                        onClick={() =>
                                            removerRequisito(index)
                                        }
                                    >
                                        ✕
                                    </button>

                                </div>

                            )
                        )}

                    </div>

                </div>

                {/* Benefícios */}

                <div className="lista-box">

                    <h3>Benefícios</h3>

                    <div className="linha-add">

                        <input
                            value={beneficio}
                            onChange={(e) =>
                                setBeneficio(e.target.value)
                            }
                        />

                        <button
                            type="button"
                            onClick={adicionarBeneficio}
                        >
                            Adicionar
                        </button>

                    </div>

                    <div className="itens-lista">

                        {beneficios.map(
                            (item, index) => (

                                <div
                                    className="item-lista"
                                    key={index}
                                >

                                    <span>{item}</span>

                                    <button
                                        type="button"
                                        className="btn-remover"
                                        onClick={() =>
                                            removerBeneficio(index)
                                        }
                                    >
                                        ✕
                                    </button>

                                </div>

                            )
                        )}

                    </div>

                </div>

            </div>

            {erro && (

                <div className="erro-vaga">

                    {erro}

                </div>

            )}

            <div className="rodape-modal">

                <button
                    className="btn-cancelar"
                    type="button"
                    onClick={onClose}
                >
                    Cancelar
                </button>

                <button
                    className="btn-salvar"
                    type="button"
                    disabled={loading}
                    onClick={criarVaga}
                >
                    {loading
                        ? "Criando..."
                        : "Criar Vaga"}
                </button>

            </div>

        </div>

    </div>

);

}
                                    